module.exports = __webpack_public_path__ + "img/drop.881c9500.svg";